import { useAppContext } from '../../context/shared'
import { formatAmount } from '../../lib/utils/amount'
import styles from '../../styles/GiftCardOption.module.css'

const GiftCardOption = (props: {
  price: string
  active?: boolean
  onClick: () => any
}) => {
  const { localization, locale } = useAppContext()
  return (
    <div
      className={[styles.container, (props.active ? styles.active : '')].join(' ')}
      onClick={() => props.onClick()}
    >
      <div className={[styles.title].join(' ')}>{formatAmount(props.price, locale)}</div>
      <div className={styles.description}>{localization.gift_cards_option_description}</div>
    </div>
  )
}

export default GiftCardOption